import { NormalizedJackpotsType } from '../../types';

const defaultJackpot = {
  jackpot: {
    activationAmount: 0,
    activationAmountAdditionalCurrencies: {},
    additionalCurrencies: {},
    amount: 0,
    amountCoef: 0,
    currency: '',
    lastWinner: {
      additionalCurrencies: {},
      amount: 0,
      currency: '',
      gameId: '',
      reportedAt: { date: '', timezone: '', timezoneType: 0 },
      serviceId: 0,
      userId: '',
      convertedAmount: 0
    },
    maxWinner: {
      additionalCurrencies: {},
      amount: 0,
      currency: '',
      gameId: '',
      reportedAt: { date: '', timezone: '', timezoneType: 0 },
      serviceId: 0,
      userId: '',
      convertedAmount: 0
    },
    order: 0,
    refreshRate: 0,
    total: 0,
    convertedCurrency: '',
    convertedAmount: 0,
    convertedActivationAmount: 0
  }
};

export const defaultJackpots: NormalizedJackpotsType = {
  major: { ...defaultJackpot.jackpot },
  mega: { ...defaultJackpot.jackpot },
  mini: { ...defaultJackpot.jackpot },
  minor: { ...defaultJackpot.jackpot }
};
